// 预约记录 Mock（对齐预约表的字段）
// 界面不暴露表名/字段名
//
// 预约流程：
//   用户在小程序提交预约（参观访问 / 活动）→ 后台出现在本列表
//   → 管理端分配接送服务人员 → 到访时补录到达时间 → 预约中 → 完成后结束
//   取消不走删除，状态置为已取消，记录保留

import { ACTIVITY_LIST } from './activity'
import { DEPT_LIST, PERSON_LIST } from './system'

// 预约类型：仅「已知类型」的快捷选项（筛选下拉与文案兜底用）
// 类型由后端原样存前端传的数字、不做有效性校验，所以这里不是白名单，
// 新类型（4、5…）不用改这里也能存能筛，补上标签只是为了显示得更友好
export const APPOINTMENT_TYPE = [
  { label: '参观访问', value: 1 },
  { label: '活动', value: 2 },
  { label: '基地预约', value: 3 }
]

// 预约状态：0待补录到达时间 1预约中 2预约完成 3已结束 4已取消
export const APPOINTMENT_STATUS = [
  { label: '待补录到达时间', value: 0, tagType: 'warning' },
  { label: '预约中', value: 1, tagType: '' },
  { label: '预约完成', value: 2, tagType: 'success' },
  { label: '已结束', value: 3, tagType: 'info' },
  { label: '已取消', value: 4, tagType: 'danger' }
]

export function appointTypeText(value) {
  const hit = APPOINTMENT_TYPE.find(t => t.value === value)
  return hit ? hit.label : '未知'
}

export function appointTypeTagType(value) {
  if (value === 2) return 'warning'
  if (value === 3) return 'danger'
  return 'success'
}

export function appointStatusText(status) {
  const hit = APPOINTMENT_STATUS.find(s => s.value === status)
  return hit ? hit.label : '未知'
}

export function appointStatusTagType(status) {
  const hit = APPOINTMENT_STATUS.find(s => s.value === status)
  return hit ? hit.tagType : 'info'
}

export function genderText(gender) {
  if (gender === 1) return '男'
  if (gender === 2) return '女'
  return '未知'
}

// 活动名称（type=2 的预约关联活动）
export function activityName(id) {
  const hit = ACTIVITY_LIST.find(a => a.id === id)
  return hit ? hit.name : '—'
}

// 人员岗位（系统人员档案里的岗位字段）
export const STAFF_POSITION = {
  operation: '运营',
  reception: '接待',
  pickup: '接送',
  guide: '讲解'
}

export function staffPositionText(position) {
  return STAFF_POSITION[position] || '其他'
}

// 所属部门全路径
function deptPath(deptId) {
  const chain = []
  let dept = DEPT_LIST.find(d => d.id === deptId)
  while (dept) {
    chain.unshift(dept.name)
    dept = DEPT_LIST.find(d => d.id === dept.parent_id)
  }
  return chain.join('·')
}

// 预约记录
export const APPOINTMENT_LIST = [
  {
    id: 10231, type: 2, activity_id: 1, user_id: 101, name: '周慧兰', gender: 2,
    appoint_date: '2026-10-01', people_count: 2, arrive_time: null,
    emergency_name: '周建平', emergency_phone: '13701234567',
    service_id: 0, status: 0,
    created_at: '2026-09-11 09:12:40'
  },
  {
    id: 10230, type: 1, activity_id: 0, user_id: 102, name: '李国强', gender: 1,
    appoint_date: '2026-09-13', people_count: 4, arrive_time: null,
    emergency_name: '李婷', emergency_phone: '13612348899',
    service_id: 6, status: 1,
    created_at: '2026-09-10 16:48:02'
  },
  {
    id: 10229, type: 1, activity_id: 0, user_id: 103, name: '陈美玲', gender: 2,
    appoint_date: '2026-09-12', people_count: 1, arrive_time: '2026-09-12 09:20:00',
    emergency_name: '陈志远', emergency_phone: '13500007788',
    service_id: 5, status: 1,
    created_at: '2026-09-10 11:05:33'
  },
  {
    id: 10228, type: 2, activity_id: 4, user_id: 104, name: '王建国', gender: 1,
    appoint_date: '2026-09-15', people_count: 6, arrive_time: null,
    emergency_name: '王丽', emergency_phone: '13322334455',
    service_id: 0, status: 0,
    created_at: '2026-09-10 09:31:18'
  },
  {
    id: 10227, type: 1, activity_id: 0, user_id: 105, name: '刘桂芳', gender: 2,
    appoint_date: '2026-09-09', people_count: 3, arrive_time: '2026-09-09 10:05:00',
    emergency_name: '刘伟', emergency_phone: '13877886655',
    service_id: 6, status: 2,
    created_at: '2026-09-07 14:22:09'
  },
  {
    id: 10226, type: 2, activity_id: 3, user_id: 106, name: '赵鹏', gender: 1,
    appoint_date: '2026-09-20', people_count: 2, arrive_time: null,
    emergency_name: '赵小燕', emergency_phone: '13511223344',
    service_id: 7, status: 1,
    created_at: '2026-09-07 10:47:51'
  },
  {
    id: 10225, type: 1, activity_id: 0, user_id: 107, name: '孙秀英', gender: 2,
    appoint_date: '2026-09-06', people_count: 5, arrive_time: '2026-09-06 08:50:00',
    emergency_name: '孙浩', emergency_phone: '13909876543',
    service_id: 5, status: 3,
    created_at: '2026-09-04 15:36:20'
  },
  {
    id: 10224, type: 1, activity_id: 0, user_id: 108, name: '吴德明', gender: 1,
    appoint_date: '2026-09-08', people_count: 2, arrive_time: null,
    emergency_name: '吴小凤', emergency_phone: '13655667788',
    service_id: 0, status: 4,
    created_at: '2026-09-04 09:18:44'
  },
  {
    id: 10223, type: 2, activity_id: 1, user_id: 109, name: '郑淑珍', gender: 2,
    appoint_date: '2026-10-02', people_count: 8, arrive_time: null,
    emergency_name: '郑海', emergency_phone: '13722998877',
    service_id: 0, status: 0,
    created_at: '2026-09-03 17:02:11'
  },
  {
    id: 10222, type: 1, activity_id: 0, user_id: 110, name: '马文斌', gender: 1,
    appoint_date: '2026-09-05', people_count: 1, arrive_time: '2026-09-05 13:40:00',
    emergency_name: '马莉', emergency_phone: '13466778899',
    service_id: 6, status: 3,
    created_at: '2026-09-02 11:29:07'
  },
  {
    id: 10221, type: 1, activity_id: 0, user_id: 111, name: '何玉梅', gender: 2,
    appoint_date: '2026-09-11', people_count: 3, arrive_time: null,
    emergency_name: '何强', emergency_phone: '13388776655',
    service_id: 5, status: 1,
    created_at: '2026-09-01 16:50:38'
  },
  {
    id: 10220, type: 2, activity_id: 4, user_id: 112, name: '许长根', gender: 1,
    appoint_date: '2026-09-14', people_count: 4, arrive_time: null,
    emergency_name: '许晴', emergency_phone: '13855443322',
    service_id: 0, status: 0,
    created_at: '2026-09-01 10:14:26'
  },
  {
    id: 10219, type: 1, activity_id: 0, user_id: 113, name: '罗秀云', gender: 2,
    appoint_date: '2026-08-30', people_count: 2, arrive_time: '2026-08-30 09:15:00',
    emergency_name: '罗盛', emergency_phone: '13577889900',
    service_id: 7, status: 3,
    created_at: '2026-08-28 14:03:52'
  },
  {
    id: 10218, type: 1, activity_id: 0, user_id: 114, name: '高志刚', gender: 1,
    appoint_date: '2026-08-29', people_count: 1, arrive_time: null,
    emergency_name: '高敏', emergency_phone: '13622334411',
    service_id: 0, status: 4,
    created_at: '2026-08-26 09:41:19'
  }
]

// 可分配的工作人员：接送服务由接待 / 接送 / 讲解岗承担（运营、开发等岗位不在分配范围）
export const SERVICE_POSITIONS = ['reception', 'pickup', 'guide']

export function staffOptions() {
  return PERSON_LIST
    .filter(p => p.status === 1 && SERVICE_POSITIONS.indexOf(p.position) > -1)
    .map(p => ({
      id: p.id,
      name: p.name,
      phone: p.phone,
      position: p.position,
      position_text: staffPositionText(p.position),
      dept_name: deptPath(p.dept_id),
      external: p.type === 2
    }))
}

// 某工作人员当前在途的预约量（已分配给他、且还没结束的预约）
export function staffLoad(staffId) {
  return APPOINTMENT_LIST.filter(
    a => a.service_id === staffId && [0, 1, 2].indexOf(a.status) > -1
  ).length
}

// 接送人员展示文案
export function serviceStaffText(id) {
  if (!id) return ''
  const hit = PERSON_LIST.find(p => p.id === id)
  return hit ? hit.name : ''
}

export function serviceStaffPosition(id) {
  const hit = PERSON_LIST.find(p => p.id === id)
  return hit ? staffPositionText(hit.position) : ''
}

// 头部统计
export function appointStats(list) {
  const rows = list || APPOINTMENT_LIST
  const count = s => rows.filter(a => a.status === s).length
  return {
    total: rows.length,
    pending: count(0),
    ongoing: count(1),
    finished: count(2) + count(3),
    canceled: count(4),
    unassigned: rows.filter(a => !a.service_id && [0, 1, 2].indexOf(a.status) > -1).length
  }
}

// 时间戳文案：2026-09-11 09:12:40 → 09-11 09:12
export function shortTime(text) {
  if (!text) return ''
  const s = String(text)
  return s.length >= 16 ? s.slice(5, 16) : s
}
